module.exports = __webpack_public_path__ + "img/account-1.2a2350be.png";